import { render, staticRenderFns } from "./CoursesPage.vue?vue&type=template&id=35bbd2bb&"
import script from "./CoursesPage.vue?vue&type=script&lang=js&"
export * from "./CoursesPage.vue?vue&type=script&lang=js&"
import style0 from "./CoursesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports